// extracted by mini-css-extract-plugin
export default {"CustomLoader":"CustomLoader_CustomLoader__PNG4v"};